module.exports = __webpack_public_path__ + "img/steel.9a16bf71.png";